import React, { useContext } from 'react';

import { SpecificationItem } from '../../components';
import { Visible } from '../../core/components';
import { PriceEvolution } from '../../product/components';
import { useResourcePriceAnalytics } from '../../product/hooks';
import { UserContext } from '../../contexts';
import { isRcOrDaoStaff } from '../../core/config/storeId';

const PriceAnalytics = ({ listing, isProductPreview, isFirst, product }) => {
  const { user } = useContext(UserContext);
  const resource = isProductPreview ? 'products' : 'listings';
  const resourceId = listing?.id;
  // DAO Watches' proprietary market intelligence: RC master admins or the
  // DAO/RC-master store only (the API already returns [] to everyone else —
  // this hides the whole "Price Analytics" block, heading included).
  // Was `is_dao_admin` (= is_admin && !is_merchant), which showed it to every
  // non-merchant tenant store admin.
  const canLoad =
    isRcOrDaoStaff(user) &&
    (isProductPreview || !listing?.needsConfirmation);

  const { analytics, isLoadingAnalytics } = useResourcePriceAnalytics(
    resource,
    resourceId,
    { enabled: canLoad }
  );

  if (!canLoad) {
    return null;
  }

  const evolutionRendered = <PriceEvolution {...{ analytics }} />;

  return (
    <>
      <Visible when={isProductPreview && !isFirst}>
        <></>
      </Visible>

      <Visible when={!isProductPreview}>
        <h3 className="mt-4">Price Analytics</h3>
      </Visible>
      {!isProductPreview ? (
        <>
          <SpecificationItem
            label="RETAIL PRICE"
            value={product?.values?.price_gbp?.value}
            currency
          />
          <SpecificationItem
            label="RETAIL PRICE"
            value={product?.values?.price_euro?.value}
            currency="eur"
          />
        </>
      ) : (
        ''
      )}

      <SpecificationItem
        label="Market Price"
        value={isLoadingAnalytics ? '—' : analytics?.market}
        currency="GBP"
        na
      />
      <SpecificationItem label="Evolution" value={evolutionRendered} />
    </>
  );
};

export default PriceAnalytics;
